export default __webpack_public_path__ + "static/media/news-thumb3.dc21e1ad.png";